<template>
  <div style="background:#f5f5f5;min-height:100vh">
    <div class="van-nav-bar van-nav-bar--fixed" style="background:#fff">
      <div class="van-nav-bar__content">
        <div class="van-nav-bar__left" @click="$router.back()">
          <i class="van-icon van-icon-arrow-left van-nav-bar__arrow"></i>
        </div>
        <div class="van-nav-bar__title van-ellipsis">合营制度</div>
      </div>
    </div>
    <div style="padding-top:46px;overflow-y:auto;padding-bottom:80px">
      <!-- 顶部概览 -->
      <div style="background:linear-gradient(135deg,#5d75a2,#8fa5cc);padding:20px;color:#fff;text-align:center">
        <div style="font-size:20px;font-weight:700;margin-bottom:6px">本月概览</div>
        <div style="display:flex;justify-content:space-around;margin-top:14px">
          <div>
            <div style="font-size:22px;font-weight:700">{{ overview.totalMembers }}</div>
            <div style="font-size:12px;opacity:.8;margin-top:4px">团队人数</div>
          </div>
          <div>
            <div style="font-size:22px;font-weight:700">¥{{ overview.totalCommission }}</div>
            <div style="font-size:12px;opacity:.8;margin-top:4px">本月佣金</div>
          </div>
          <div>
            <div style="font-size:22px;font-weight:700">{{ overview.directMembers }}</div>
            <div style="font-size:12px;opacity:.8;margin-top:4px">直属人数</div>
          </div>
        </div>
      </div>

      <!-- Tab切换 -->
      <div style="display:flex;background:#fff;border-bottom:1px solid #eee">
        <div v-for="(tab,i) in tabs" :key="i"
          @click="activeTab=i"
          style="flex:1;text-align:center;padding:12px 0;font-size:14px;cursor:pointer"
          :style="activeTab===i ? 'color:#5d75a2;border-bottom:2px solid #5d75a2;font-weight:600' : 'color:#999'">
          {{ tab }}
        </div>
      </div>

      <!-- 全部 -->
      <div v-if="activeTab===0" style="padding:12px">
        <div v-for="(item,i) in allList" :key="i" style="background:#fff;border-radius:8px;padding:14px;margin-bottom:10px">
          <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px">
            <span style="color:#333;font-weight:600">{{ item.username }}</span>
            <span style="color:#999;font-size:12px">{{ item.date }}</span>
          </div>
          <div style="display:grid;grid-template-columns:1fr 1fr;gap:6px;font-size:12px">
            <div style="color:#666">充值：<span style="color:#333">¥{{ item.recharge }}</span></div>
            <div style="color:#666">提现：<span style="color:#333">¥{{ item.withdraw }}</span></div>
            <div style="color:#666">投注：<span style="color:#333">¥{{ item.bet }}</span></div>
            <div style="color:#666">盈亏：<span style="color:#e74c3c">¥{{ item.profit }}</span></div>
            <div style="color:#666">返水：<span style="color:#333">¥{{ item.fanshui }}</span></div>
            <div style="color:#666">彩金：<span style="color:#333">¥{{ item.caijin }}</span></div>
            <div style="color:#666">余额：<span style="color:#333">¥{{ item.balance }}</span></div>
          </div>
        </div>
        <div v-if="allList.length===0" style="text-align:center;color:#ccc;padding:40px 0">暂无数据</div>
      </div>

      <!-- 直属 -->
      <div v-if="activeTab===1" style="padding:12px">
        <div v-for="(item,i) in directList" :key="i" style="background:#fff;border-radius:8px;padding:14px;margin-bottom:10px">
          <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px">
            <span style="color:#333;font-weight:600">{{ item.username }}</span>
            <span style="color:#999;font-size:12px">{{ item.date }}</span>
          </div>
          <div style="display:grid;grid-template-columns:1fr 1fr;gap:6px;font-size:12px">
            <div style="color:#666">充值：<span style="color:#333">¥{{ item.recharge }}</span></div>
            <div style="color:#666">提现：<span style="color:#333">¥{{ item.withdraw }}</span></div>
            <div style="color:#666">投注：<span style="color:#333">¥{{ item.bet }}</span></div>
            <div style="color:#666">盈亏：<span style="color:#e74c3c">¥{{ item.profit }}</span></div>
            <div style="color:#666">返水：<span style="color:#333">¥{{ item.fanshui }}</span></div>
            <div style="color:#666">彩金：<span style="color:#333">¥{{ item.caijin }}</span></div>
            <div style="color:#666">余额：<span style="color:#333">¥{{ item.balance }}</span></div>
          </div>
        </div>
        <div v-if="directList.length===0" style="text-align:center;color:#ccc;padding:40px 0">暂无数据</div>
      </div>

      <!-- 团队 -->
      <div v-if="activeTab===2" style="padding:12px">
        <div v-for="(item,i) in teamList" :key="i" style="background:#fff;border-radius:8px;padding:14px;margin-bottom:10px">
          <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px">
            <span style="color:#333;font-weight:600">{{ item.username }}</span>
            <span style="color:#999;font-size:12px">{{ item.date }}</span>
          </div>
          <div style="display:grid;grid-template-columns:1fr 1fr;gap:6px;font-size:12px">
            <div style="color:#666">充值：<span style="color:#333">¥{{ item.recharge }}</span></div>
            <div style="color:#666">提现：<span style="color:#333">¥{{ item.withdraw }}</span></div>
            <div style="color:#666">投注：<span style="color:#333">¥{{ item.bet }}</span></div>
            <div style="color:#666">盈亏：<span style="color:#e74c3c">¥{{ item.profit }}</span></div>
            <div style="color:#666">返水：<span style="color:#333">¥{{ item.fanshui }}</span></div>
            <div style="color:#666">彩金：<span style="color:#333">¥{{ item.caijin }}</span></div>
            <div style="color:#666">余额：<span style="color:#333">¥{{ item.balance }}</span></div>
          </div>
        </div>
        <div v-if="teamList.length===0" style="text-align:center;color:#ccc;padding:40px 0">暂无数据</div>
      </div>

      <!-- 财务报表 -->
      <div v-if="activeTab===3" style="padding:12px">
        <div style="background:#fff;border-radius:8px;padding:16px">
          <div style="display:flex;justify-content:space-between;padding:10px 0;border-bottom:1px solid #f5f5f5">
            <span style="color:#666">本月总投注</span><span style="color:#333;font-weight:600">¥{{ report.totalBet }}</span>
          </div>
          <div style="display:flex;justify-content:space-between;padding:10px 0;border-bottom:1px solid #f5f5f5">
            <span style="color:#666">本月总盈亏</span><span style="color:#333;font-weight:600">¥{{ report.totalProfit }}</span>
          </div>
          <div style="display:flex;justify-content:space-between;padding:10px 0;border-bottom:1px solid #f5f5f5">
            <span style="color:#666">本月佣金</span><span style="color:#5d75a2;font-weight:600">¥{{ report.commission }}</span>
          </div>
          <div style="display:flex;justify-content:space-between;padding:10px 0">
            <span style="color:#666">新增会员</span><span style="color:#333;font-weight:600">{{ report.newMembers }}人</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'agentIntro',
  data() {
    return {
      activeTab: 0,
      tabs: ['全部', '直属', '团队', '财务报表'],
      overview: { totalMembers: 0, totalCommission: '0.00', directMembers: 0 },
      allList: [],
      directList: [],
      teamList: [],
      report: { totalBet: '0.00', totalProfit: '0.00', commission: '0.00', newMembers: 0 },
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      let that = this;
      that.$apiFun.post('/api/agent/overview', {}).then(res => {
        if (res.code === 200) {
          that.overview = res.data.overview || that.overview;
          that.allList = res.data.allList || [];
          that.directList = res.data.directList || [];
          that.teamList = res.data.teamList || [];
          that.report = res.data.report || that.report;
        }
      }).catch(() => {});
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/agentIntro.vue